import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ChevronDown, Loader2, Save, Tag } from "lucide-react";

const MATS = [["base", "Base"], ["trasparente", "Trasparente"], ["pastello", "Pastello"], ["fondo", "Fondo"], ["varie", "Varie"]];
const UNITS = [["lt", "€/litro"], ["kg", "€/kg"], ["pz", "€/pezzo"]];
const toNum = (v) => parseFloat(String(v).replace(",", ".")) || 0;

export const MaterialPrices = ({ defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    api.get("/admin/material-prices").then((r) => setP(Object.fromEntries(MATS.map(([k]) => {
      const v = r.data.prices[k] || {};
      return [k, { price: v.price ? String(v.price).replace(".", ",") : "", unit: v.unit || (k === "varie" ? "pz" : "lt") }];
    })))).catch(() => {});
  }, []);
  const set = (k, f, v) => setP({ ...p, [k]: { ...p[k], [f]: v } });
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/material-prices", { prices: Object.fromEntries(MATS.map(([k]) => [k, { price: toNum(p[k].price), unit: p[k].unit }])) });
      toast.success("Prezzi materiali salvati");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const set_count = p ? MATS.filter(([k]) => toNum(p[k].price) > 0).length : 0;

  return (
    <section className={defaultOpen ? "" : "rounded-xl border border-white/10 bg-[#181A22]"} data-testid="material-prices">
      {!defaultOpen && <button onClick={() => setOpen(!open)} className="w-full p-4 flex items-center gap-2 text-left" data-testid="material-prices-toggle">
        <Tag className="w-4 h-4 text-[#FF9E00]" />
        <span className="font-display font-bold uppercase text-sm mr-auto">Prezzi materiali</span>
        <span className="text-xs text-muted-foreground">{set_count}/5 impostati</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>}
      {open && p && (
        <div className={defaultOpen ? "space-y-2" : "px-4 pb-4 space-y-2"}>
          <p className="text-xs text-muted-foreground">Se l'operatore scrive solo la quantità (es. 0,5 lt) il costo si calcola con questi prezzi. Gli importi già scritti in euro restano quelli.</p>
          {MATS.map(([k, label]) => (
            <div key={k} className="grid grid-cols-[1fr_96px_110px] gap-2 items-center" data-testid={`material-price-${k}`}>
              <span className="text-sm font-semibold">{label}</span>
              <Input value={p[k].price} onChange={(e) => set(k, "price", e.target.value)} inputMode="decimal" placeholder="0,00" className="text-right bg-[#12141A] border-white/10" data-testid={`material-price-${k}-price`} />
              <select value={p[k].unit} onChange={(e) => set(k, "unit", e.target.value)} className="h-10 rounded-md bg-[#12141A] border border-white/10 px-2 text-sm" data-testid={`material-price-${k}-unit`}>
                {UNITS.map(([u, l]) => <option key={u} value={u}>{l}</option>)}
              </select>
            </div>
          ))}
          <div className="flex justify-end">
            <Button onClick={save} disabled={busy} className="rounded-full bg-[#E63946] hover:bg-[#D62828] text-white" data-testid="material-prices-save">
              {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />}Salva prezzi
            </Button>
          </div>
        </div>
      )}
    </section>
  );
};
